export default class Header {

	constructor(el) {

		this.DOM = { el: el };
		this.DOM.body = document.body;
		this.DOM.html = document.documentElement;
		this.DOM.NavContainer = document.querySelector('.Nav__container');
		this.DOM.brand = this.DOM.el.querySelector('.brand');
		this.DOM.toggle = this.DOM.el.querySelector('.Toggle__menu');
		this.DOM.menuContainer = this.DOM.el.querySelector('Nav__container');

		this.menuOpen = false;

		this.init();

	}

	init() {

		//if (window.DEVMODE) console.log('initHeader');

	// Toggle
	this.DOM.toggle.addEventListener('click', (e) => {

		e.preventDefault();
		this.menuOpen === true ? this.close() : this.open();

	});
}

open() {

	return new Promise((resolve, reject) => {

		// Console.log('Open Menu');
		this.menuOpen = true;
		this.DOM.body.classList.add('showMenu');
		this.DOM.body.style.overflow = 'hidden';
		document.documentElement.style.overflow = 'hidden';

		const openMenu = new TimelineMax({paused:true, onComplete:() => {
			this.menuAnimating = false;
		}})
		openMenu.fromTo(document.querySelector(".header__panel--before"), 1.2, {x:"-100%"}, {x:"100%", ease:Power3.easeInOut}, 0);
		openMenu.fromTo(document.querySelector(".language"), 1.2, {y:"0"}, {y:"-200px", ease:Power3.easeInOut}, 0);
		openMenu.fromTo(document.querySelector(".brand"), 1.2, {y:"0"}, {y:"-200px", ease:Power3.easeInOut}, 0);
		openMenu.fromTo(document.querySelector(".header__panel--bg"), 0.6, {x:"-100%"}, {x:"0%", ease:Power3.easeInOut}, 0.3);
		openMenu.staggerFromTo(document.querySelectorAll(".Nav__main >li "), 0.4, {y:"40px", opacity:0}, {y:"0", opacity:1, ease:Power3.easeInOut}, 0.1);
		openMenu.play();

	});

}

close() {

	return new Promise((resolve, reject) => {

	  // Console.log('Close Menu');
	  this.menuOpen = false;
	  //this.DOM.body.classList.remove('showMenu');
	  this.DOM.body.style.overflow = '';
	  document.documentElement.style.overflow = '';

		const closeMenu = new TimelineMax({paused:true, onComplete:() => {
			this.menuAnimating = false;
			this.DOM.body.classList.remove('showMenu');
		}})
		closeMenu.staggerFromTo(document.querySelectorAll(".Nav__main >li "), 0.4, {y:"0px", opacity:1}, {y:"40", opacity:0, ease:Power3.easeInOut}, 0.1);
		closeMenu.fromTo(document.querySelector(".header__panel--bg"), 0.6, {x:"0%"}, {x:"-100%", ease:Power3.easeInOut}, 0.2);
		closeMenu.fromTo(document.querySelector(".header__panel--before"), 1.2, {x:"00%"}, {x:"-100%", ease:Power3.easeInOut}, 0.5);
		closeMenu.fromTo(document.querySelector(".language"), 1.2, {y:"-200px"}, {y:"0px", ease:Power3.easeInOut}, 0);
		closeMenu.fromTo(document.querySelector(".brand"), 1.2, {y:"-200px"}, {y:"0px", ease:Power3.easeInOut}, 0);
		closeMenu.play();

	});

}

}
